/**
 * Features releases store
 * Used only to get and read features
 */

import { getReleaseFeatures, viewReleaseFeature } from '../../Api/user-release-features';

const state = {};
const actions = {
    getFeatures: async () => {
        return await getReleaseFeatures();
    },
    viewFeatures: async () => {
        return await viewReleaseFeature();
    },
};
const getters = {};
const mutations = {};

export default {
    actions,
    getters,
    mutations,
    namespaced: true,
    state,
};
